
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ClientDetectionResponse,
  UpdateIdentifiedClientRefRequest,
  UpdateIdentifiedClientRequest,
  UpdateReferredClientRequest,
} from '../models';
import {
    ClientDetectionResponseFromJSON,
    ClientDetectionResponseToJSON,
    UpdateIdentifiedClientRefRequestFromJSON,
    UpdateIdentifiedClientRefRequestToJSON,
    UpdateIdentifiedClientRequestFromJSON,
    UpdateIdentifiedClientRequestToJSON,
    UpdateReferredClientRequestFromJSON,
    UpdateReferredClientRequestToJSON,
} from '../models';

export interface ClientDetectionRequest {
    submissionId: string;
}

export interface UpdateIdentifiedClientOperationRequest {
    submissionId: string;
    updateIdentifiedClientRequest: UpdateIdentifiedClientRequest;
}

export interface UpdateIdentifiedClientRefOperationRequest {
    submissionId: string;
    updateIdentifiedClientRefRequest: UpdateIdentifiedClientRefRequest;
}

export interface UpdateReferredClientOperationRequest {
    submissionId: string;
    updateReferredClientRequest: UpdateReferredClientRequest;
}

/**
 * 
 */
export class EligibilityClientApi extends runtime.BaseAPI {

    /**
     * Run client detection based on referred client
          */
    async clientDetectionRaw(requestParameters: ClientDetectionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientDetectionResponse>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling clientDetection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientDetectionResponse>({
            path: `/business-referral/api/eligibility/{submissionId}/run-client-detection`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientDetectionResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Run client detection based on referred client
          */
    async clientDetection(requestParameters: ClientDetectionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientDetectionResponse> {
        const response = await this.clientDetectionRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update identified client company for a given referral submission
          */
    async updateIdentifiedClientRaw(requestParameters: UpdateIdentifiedClientOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling updateIdentifiedClient().'
            );
        }

        if (requestParameters['updateIdentifiedClientRequest'] == null) {
            throw new runtime.RequiredError(
                'updateIdentifiedClientRequest',
                'Required parameter "updateIdentifiedClientRequest" was null or undefined when calling updateIdentifiedClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/business-referral/api/eligibility/{submissionId}/identified-client`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateIdentifiedClientRequestToJSON(requestParameters['updateIdentifiedClientRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update identified client company for a given referral submission
          */
    async updateIdentifiedClient(requestParameters: UpdateIdentifiedClientOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateIdentifiedClientRaw(requestParameters, initOverrides);
    }

    /**
     * Update identified client reference for a given client company
          */
    async updateIdentifiedClientRefRaw(requestParameters: UpdateIdentifiedClientRefOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling updateIdentifiedClientRef().'
            );
        }

        if (requestParameters['updateIdentifiedClientRefRequest'] == null) {
            throw new runtime.RequiredError(
                'updateIdentifiedClientRefRequest',
                'Required parameter "updateIdentifiedClientRefRequest" was null or undefined when calling updateIdentifiedClientRef().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/business-referral/api/eligibility/{submissionId}/identified-client-ref`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateIdentifiedClientRefRequestToJSON(requestParameters['updateIdentifiedClientRefRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update identified client reference for a given client company
          */
    async updateIdentifiedClientRef(requestParameters: UpdateIdentifiedClientRefOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateIdentifiedClientRefRaw(requestParameters, initOverrides);
    }

    /**
     * Update referred client details
          */
    async updateReferredClientRaw(requestParameters: UpdateReferredClientOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['submissionId'] == null) {
            throw new runtime.RequiredError(
                'submissionId',
                'Required parameter "submissionId" was null or undefined when calling updateReferredClient().'
            );
        }

        if (requestParameters['updateReferredClientRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReferredClientRequest',
                'Required parameter "updateReferredClientRequest" was null or undefined when calling updateReferredClient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/business-referral/api/eligibility/{submissionId}/referred-client`.replace(`{${"submissionId"}}`, encodeURIComponent(String(requestParameters['submissionId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReferredClientRequestToJSON(requestParameters['updateReferredClientRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update referred client details
          */
    async updateReferredClient(requestParameters: UpdateReferredClientOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReferredClientRaw(requestParameters, initOverrides);
    }

}
